<template>
	<section v-if="showQuickReply" class="w-full px-24">
		<h3 class="text-gray-300 font-semibold mb-8 float-left mr-16">Quick reply</h3>
		<div v-if="state === 'sending'" class="text-gray-400">
			<BaseIcon name="mono/load" />
			Sending...
		</div>
		<div v-if="state === 'success'" class="text-green-500">
			<BaseIcon name="mono/check" class="mb-4" />
			Sent!
		</div>
		<div v-if="state === 'error'" class="text-red-500">
			<BaseIcon name="mono/error" class="mb-2" />
			Ops, there was an error. Please try again.
		</div>
		<ul class="flex gap-8 flex-wrap w-full">
			<li v-for="(reply, index) in replies" :key="index">
				<button
					class="button-dashed rounded text-gray-300"
					style="border-style: solid !important"
					@click="postReply(reply)"
				>
					{{ reply }}
				</button>
			</li>
		</ul>
	</section>
</template>

<script>
import delay from 'shared/utils/delay'
import analytics from 'shared/utils/analytics'
import {useSessionStore} from 'shared/stores/session'

export default {
	name: 'SessionDevToolsQuickReply',
	setup() {
		return {sessionStore: useSessionStore()}
	},
	data() {
		return {
			replies: [
				"👍 Thanks, I'm on it!",
				'👀 Looking into this',
				"😕 I can't reproduce",
				'✅ Found the issue',
				'🚀 Deployed the fix',
				'🙏 This bug report was helpful!',
			],
			state: 'idle',
		}
	},
	computed: {
		showQuickReply() {
			if (this.$store.isExtension) return false
			return this.sessionStore.canUserEditSession
		},
	},
	methods: {
		async postReply(content) {
			if (this.state === 'sending') return
			this.state = 'sending'
			analytics.track('Quick Reply Sent', {content})
			try {
				await this.$api.post('/comments', {
					comment: {content},
					sessionId: this.$route.params.sessionId,
				})
				this.state = 'success'
			} catch (error) {
				this.state = 'error'
			} finally {
				await delay(3000)
				this.state = 'idle'
			}
		},
	},
}
</script>
